export enum SeeingVetAnswer { 
    No,
    Yes,
    YesForUnreleatedIssue
}